import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NatTabsComponent } from '@natiwi/shared/tabs/tabs.component';
import { RouterModule } from '@angular/router';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';

@NgModule({
  declarations: [NatTabsComponent],
  imports: [
    CommonModule,
    RouterModule,
    MatIconModule,
    MatButtonModule,
    MatTabsModule,
    MatRippleModule
  ],
  exports: [NatTabsComponent],
  providers: []
})
export class NatTabsModule { }
